import { createFileRoute } from "@tanstack/react-router";
import { ensureRouteTranslationModuleLoaded } from "@/services/culture/routeTranslationPreload";

export const Route = createFileRoute("/resources")({
  beforeLoad: async () => {
    await ensureRouteTranslationModuleLoaded("resources");
  },
  staticData: {
    title: "apps.resources",
  },
});
